<div
  class="searchable-select"
  [class.open]="open"
  [class.disabled]="disabled"
  [class.has-value]="!!displayLabel"
>
  <button
    #triggerBtn
    type="button"
    class="searchable-select-trigger"
    (click)="toggle($event)"
    [disabled]="disabled"
    [attr.aria-expanded]="open"
    aria-haspopup="listbox"
  >
    <span class="searchable-select-value" [class.placeholder]="!displayLabel">
      {{ displayLabel || placeholder }}
    </span>
    <mat-icon class="searchable-select-chevron">{{ open ? 'expand_less' : 'expand_more' }}</mat-icon>
  </button>

  <div
    class="searchable-select-panel"
    *ngIf="open"
    role="listbox"
    [ngStyle]="panelStyle"
    (mousedown)="$event.stopPropagation()"
  >
    <div class="searchable-select-search">
      <mat-icon>search</mat-icon>
      <input
        #searchInput
        type="search"
        [placeholder]="searchPlaceholder || placeholder"
        [(ngModel)]="query"
        (ngModelChange)="onQueryChange()"
        (keydown.enter)="$event.preventDefault()"
      />
    </div>

    <div class="searchable-select-options">
      <button
        type="button"
        class="searchable-select-option"
        *ngIf="allowEmpty"
        role="option"
        [class.selected]="!value"
        (click)="select(null, $event)"
      >
        {{ emptyLabel || placeholder }}
      </button>

      <button
        type="button"
        class="searchable-select-option"
        *ngFor="let option of filteredOptions; trackBy: trackByValue"
        role="option"
        [class.selected]="option.value === value"
        (click)="select(option, $event)"
      >
        <span>{{ option.label }}</span>
        <mat-icon *ngIf="option.value === value">check</mat-icon>
      </button>

      <div class="searchable-select-empty" *ngIf="!filteredOptions.length">
        {{ 'COMMON.NO_RESULTS' | translate }}
      </div>
    </div>
  </div>
</div>
